/** Browser draft storage so in-progress reviews survive a refresh. */

import type { ArtefactRatings, PhaseRatings } from "./types";
import type { WizardStep } from "./wizardSteps";

const STORAGE_PREFIX = "ani.agent-review.draft.v1:";

export interface ReviewDraft {
  step: WizardStep;
  ratings: PhaseRatings;
  artefactRatings: ArtefactRatings;
  intentConfirmed: boolean;
  intentFeedback: string;
  savedAt: string;
}

function storageKey(runId: string): string {
  return `${STORAGE_PREFIX}${runId}`;
}

export function loadReviewDraft(runId: string): ReviewDraft | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(storageKey(runId));
    if (!raw) return null;
    return JSON.parse(raw) as ReviewDraft;
  } catch {
    return null;
  }
}

export function saveReviewDraft(runId: string, draft: Omit<ReviewDraft, "savedAt">): void {
  if (typeof window === "undefined") return;
  try {
    const payload: ReviewDraft = { ...draft, savedAt: new Date().toISOString() };
    window.localStorage.setItem(storageKey(runId), JSON.stringify(payload));
  } catch {
    /* private mode or quota — ignore */
  }
}

export function clearReviewDraft(runId: string): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(storageKey(runId));
  } catch {
    /* ignore */
  }
}
